import { Directive, TemplateRef } from "@angular/core";

@Directive({ selector: '[sub-row-template]' })
export class SubRowTemplateDirective {
    constructor(public template: TemplateRef<any>) { }
}